export const SettingsWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex h-full flex-col justify-between overflow-y-auto px-2">{children}</div>;
};
